import { Box, styled } from '@mui/material';
var StyledPopupContentContainer = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  var styles = {};
  return styles;
});
export { StyledPopupContentContainer };